var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "dataview-chart": true, "loading-graph": _vm.isLoading } },
    [
      _vm.graphIsEmpty && !_vm.filters
        ? [_vm._v("\n      No data available.\n  ")]
        : [
            _c(
              "div",
              { staticClass: "grid-25w filters" },
              [
                _vm._l(_vm.filters, function (filter) {
                  return _vm.filters
                    ? _c("treeselect", {
                        key: filter.instanceId,
                        attrs: {
                          multiple: _vm.isMultiple(filter),
                          clearable: _vm.isMultiple(filter),
                          options: filter.values,
                          placeholder: filter.name,
                          instanceId: filter.instanceId,
                        },
                        on: {
                          close: _vm.filterChanged,
                          input: _vm.filterChanged,
                        },
                        model: {
                          value: _vm.filterValues[filter.instanceId],
                          callback: function ($$v) {
                            _vm.$set(_vm.filterValues, filter.instanceId, $$v)
                          },
                          expression: "filterValues[filter.instanceId]",
                        },
                      })
                    : _vm._e()
                }),
                _vm._v(" "),
                _vm.filters && _vm.filters.length === 2 ? _c("div") : _vm._e(),
                _vm._v(" "),
                _vm.buttonLoad
                  ? _c("div", { staticStyle: { float: "right" } }, [
                      _c(
                        "button",
                        {
                          staticStyle: {
                            "margin-top": "1px",
                            width: "100%",
                            "padding-top": "4px",
                            "padding-bottom": "3px",
                          },
                          on: { click: _vm.getChartByClick },
                        },
                        [
                          _vm._v(
                            "\n                Load chart\n                "
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "8px",
                                "text-transform": "none",
                                "text-align": "center",
                              },
                            },
                            [_vm._v("(Use filters for faster load)")]
                          ),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
            _vm._v(" "),
            _vm.kpis
              ? _c(
                  "div",
                  { staticClass: "grid-25w kpis" },
                  _vm._l(_vm.kpis, function (kpi) {
                    return _c("div", [
                      _c(
                        "div",
                        { staticClass: "kpi-title" },
                        [
                          _c("h4", { class: { "with-helper": kpi.helper } }, [
                            _vm._v(_vm._s(kpi.name)),
                          ]),
                          _vm._v(" "),
                          kpi.helper
                            ? _c("HelperBox", { attrs: { text: kpi.helper } })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { class: { "with-helper": kpi.helper } }, [
                        _vm._v(_vm._s(kpi.value)),
                      ]),
                    ])
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "grid-full" },
              [
                _vm.isGantt
                  ? [
                      _vm.chart
                        ? _c("highcharts", {
                            key: _vm.rerenderKey,
                            attrs: {
                              options: _vm.chart,
                              "constructor-type": "ganttChart",
                            },
                          })
                        : _vm._e(),
                    ]
                  : [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "min-height": "400px",
                            width: "100%",
                            "min-width": "100%",
                          },
                        },
                        [
                          !_vm.autoLoadChart
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "16px",
                                    "text-align": "center",
                                    "line-height": "400px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                    Please use filters before pressing load to see chart.\n                "
                                  ),
                                ]
                              )
                            : _c(
                                "div",
                                [
                                  _vm.graphIsEmpty && _vm.filters
                                    ? [
                                        _c("div", [
                                          _vm._v(
                                            "No data with selected combination"
                                          ),
                                        ]),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.chart
                                    ? _c("highcharts", {
                                        key: _vm.rerenderKey,
                                        attrs: { options: _vm.chart },
                                      })
                                    : _vm._e(),
                                ],
                                2
                              ),
                        ]
                      ),
                    ],
                _vm._v(" "),
                _vm.loadingFailed
                  ? _c("p", [
                      _vm._v(
                        "\n            Could not load chart. Please review input data.\n        "
                      ),
                    ])
                  : _vm._e(),
              ],
              2
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }